import {InterfaceNewsItem} from "../interface/press-center/interface.news";

export class NewsStore {
    private featuredNews: InterfaceNewsItem[];
    private selectedTab: string

    constructor() {
        this.featuredNews = [];
        this.selectedTab = 'news';
    }
    public setFeaturedNews(featuredNews: InterfaceNewsItem[]): void {
        this.featuredNews = featuredNews
    }
    public getFeaturedNews(): InterfaceNewsItem[] {
        return this.featuredNews;
    }
    public setSelectedTab(tab: string) {
        this.selectedTab = tab;
    }
    public getSelectedTab(): string {
        return this.selectedTab;
    }
}
